<template>
<div class="chapter">
<div class="inner_page">
<div class="sbox">
<h2 class="subchapter" id="s006"><a id="page15"></a><span href="#/OEBPS/toc#s6" title="Link target outside of Sample"><em>Cinnamon-Pumpkin French Toast</em></span></h2>
<p class="figure"><a id="page14"></a><img alt="" src="OEBPS/images/14-1.jpg"/></p>
<p class="recipe">Yield: Serves 6 to 8 | Prep Time: 20 minutes | Cook Time: 45 minutes</p>
<p class="recipenote">I have a vivid memory of carving pumpkins with a friend on a cold fall weekend in New England. We wore cozy sweaters, drank tea, and spent the majority of the day on the floor scooping and sifting the pumpkin seeds out while a dog lapped around, doing her best to lick them up. There are plenty of things to make with pumpkin, namely that ubiquitous pie, but this is by far one of my favorite pumpkin recipes. The challah bread is sliced thick, resembling the French toast sticks I ate as a kid, and coated in a sweet cinnamon-pumpkin mixture.</p>
</div>
<p class="serves"><strong>INGREDIENTS</strong></p>
<p class="rhead"><strong>French Toast</strong></p>
<p class="indger1">2 teaspoons unsalted butter</p>
<p class="indger">1 cup heavy cream</p>
<p class="indger">3 large eggs</p>
<p class="indger">¼ cup sugar</p>
<p class="indger">1 tablespoon ground cinnamon</p>
<p class="indger">1 teaspoon vanilla extract</p>
<p class="indger">¼ teaspoon ground ginger</p>
<p class="indger">¼ teaspoon ground nutmeg</p>
<p class="indger">¼ teaspoon kosher salt</p>
<p class="indger">1 (8-ounce) can pumpkin puree</p>
<p class="indger">1 large loaf brioche or challah bread, sliced into 2-inch sticks</p>
<p class="rhead"><strong>Streusel Topping</strong></p>
<p class="indger">1 cup light brown sugar</p>
<p class="indger">¾ cup pecans, roughly chopped</p>
<p class="indger">4 tablespoons unsalted butter, cold, cut into ¼-inch cubes</p>
<p class="indger">2 teaspoons ground cinnamon</p>
<p class="rhead"><strong>Maple Butter</strong></p>
<p class="indger">8 tablespoons unsalted butter, melted</p>
<p class="indger">2 tablespoons pure maple syrup</p>
<h2 class="head"><strong>DIRECTIONS</strong></h2>
<p class="numhang">1. Preheat the oven to 350°F and butter a 9 × 13-inch baking dish.</p>
<p class="numhang">2. For the French toast: Combine the cream, eggs, sugar, cinnamon, vanilla, ginger, nutmeg, and salt in a large bowl. Whisk in the pumpkin puree until smooth. Place the bread sticks in the baking dish, add the pumpkin mixture, and gently toss to coat.</p>
<p class="numhang">3. For the streusel topping: Gently combine the brown sugar, pecans, butter, and cinnamon in a small bowl.</p>
<p class="numhang">4. Sprinkle the streusel topping over the casserole and bake for 40 to 45 minutes, until set (if the streusel starts to brown, cover with foil to finish baking).</p>
<p class="numhang">5. For the maple butter: While the casserole bakes, combine the melted butter with maple syrup in a small bowl.</p>
<p class="numhang">6. Scoop the French toast into serving bowls and serve drizzled with maple butter.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s006.vue?a1613fa8